import { MdClose } from "react-icons/md";
import { LuCalendarClock } from "react-icons/lu";
import googleMeetImg from '../../../assets/images/meet.png'
import zoomImg from '../../../assets/images/zoom.png'
import venueImg from '../../../assets/images/map.png'
import DescriptionWithLinks from "./DescriptionWithLinks";

const dateFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
}
const timeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
}

export const headerTemplate = (props, resources, scheduleRef) => {
    const resource = resources.find(item => item.Id === props?.CourtNumber);
    return (
        <div className="sm_scheduler_quick_info_header">
            {props?.elementType === 'event' &&
                <div className="sm_scheduler_quick_info_header_container" style={{ background: resource?.Color ? resource.Color :'#3f51b5', color: '#FFFFFF' }}>
                    <div className="sm_scheduler_quick_info_toolbar">
                        <MdClose onClick={() => scheduleRef.current.closeQuickInfoPopup()} className="sm_scheduler_quick_info_close_icon" />
                    </div>
                    <h2>{props.Subject}</h2>
                </div>}
        </div>
    );
}

export const contentTemplate = (props) => {
    return (
        <div className="quick-info-content">
            {props?.elementType === 'event' &&
                <div className="sm_quick_info_content_container">
                    <div className="sm_quick_info_content_timing">
                        <LuCalendarClock className="sm_quick_info_content_calendar_icon" />
                        <p>{`${props.StartTime.toLocaleDateString('en-US', dateFormatOptions)}( ${props.StartTime.toLocaleTimeString('en-US', timeFormatOptions)} - ${props.EndTime.toLocaleTimeString('en-US', timeFormatOptions)})`}</p>
                    </div>
                    {(props?.Venue && ((props.ScheduleType === 'MEETING' && props?.MeetingData?.mode === 'OFFLINE') || (props.ScheduleType === 'TEAM_PRACTICE'))) &&
                    <div className="sm_quick_info_content_location">
                        <img src={venueImg} alt="" />
                        <p>{props?.Venue}</p>
                    </div>}
                    {(props.ScheduleType === 'MEETING' && props?.MeetingData?.mode==='ONLINE') &&
                        <div className="sm_quick_info_content_meeting_data">
                            {props?.MeetingData?.platform === 'GOOGLE_MEET' &&
                                <>
                                    <img src={googleMeetImg} alt="Google meet" />
                                    <p>Google Meet</p>
                                </>
                            }
                            {props?.MeetingData?.platform === 'ZOOM' &&
                                <>
                                    <img src={zoomImg} alt="Zoom" />
                                    <p>Zoom</p>
                                </>
                            }

                        </div>}
                    <DescriptionWithLinks description={props.Description} />
                </div>
            }
        </div>
    );
}

export const footerTemplate = (props) => {
    return (<div className="quick-info-footer">
        {/* {props.elementType === "cell" ?
            <div className="cell-footer">
                <ButtonComponent id="more-details" cssClass='e-flat' content="More Details" onClick={buttonClickActions.bind(this)} />
                <ButtonComponent id="add" cssClass='e-flat' content="Add" isPrimary={true} onClick={buttonClickActions.bind(this)} />
            </div>
            :
            <div className="event-footer">
                <ButtonComponent id="delete" cssClass='e-flat' content="Delete" onClick={buttonClickActions.bind(this)} />
                <ButtonComponent id="more-details" cssClass='e-flat' content="More Details" isPrimary={true} onClick={buttonClickActions.bind(this).bind(this)} />
            </div>} */}
    </div>);
}

const getHeaderStyles = (data) => {
    if (data.elementType === 'cell') {
        return { alignItems: 'center', color: '#919191' };
    }
    else {
        const resourceData = getResourceData(data);
        return { background: resourceData.Color, color: '#FFFFFF' };
    }
}
const getHeaderTitle = (data) => {
    return (data.elementType === 'cell') ? 'Add Appointment' : 'Appointment Details';
}
const getHeaderDetails = (data) => {
    return intl.formatDate(data.StartTime, { type: 'date', skeleton: 'full' }) + ' (' +
        intl.formatDate(data.StartTime, { skeleton: 'hm' }) + ' - ' +
        intl.formatDate(data.EndTime, { skeleton: 'hm' }) + ')';
}
const getEventType = (data) => {
    const resourceData = getResourceData(data);
    return resourceData.Name;
}
const buttonClickActions = (e) => {
    const quickPopup = scheduleObj.current.element.querySelector('.e-quick-popup-wrapper');
    const getSlotData = () => {
        const cellDetails = scheduleObj.current.getCellDetails(scheduleObj.current.getSelectedElements());
        const addObj = {};
        addObj.Id = scheduleObj.current.getEventMaxID();
        addObj.Subject = titleObj.current.value;
        addObj.StartTime = new Date(+cellDetails.startTime);
        addObj.EndTime = new Date(+cellDetails.endTime);
        addObj.Description = notesObj.current.value;
        addObj.RoomId = eventTypeObj.current.value;
        return addObj;
    };
    if (e.target.id === 'add') {
        const addObj = getSlotData();
        scheduleObj.current.addEvent(addObj);
    }
    else if (e.target.id === 'delete') {
        const eventDetails = scheduleObj.current.activeEventData.event;
        let currentAction = 'Delete';
        if (eventDetails.RecurrenceRule) {
            currentAction = 'DeleteOccurrence';
        }
        scheduleObj.current.deleteEvent(eventDetails, currentAction);
    }
    else {
        const isCellPopup = quickPopup.firstElementChild.classList.contains('e-cell-popup');
        const eventDetails = isCellPopup ? getSlotData() :
            scheduleObj.current.activeEventData.event;
        let currentAction = isCellPopup ? 'Add' : 'Save';
        if (eventDetails.RecurrenceRule) {
            currentAction = 'EditOccurrence';
        }
        scheduleObj.current.openEditor(eventDetails, currentAction, true);
    }
    scheduleObj.current.closeQuickInfoPopup();
}